import React from 'react'
import Header from './Header'
import { Helmet } from 'react-helmet'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Layout = ({ children, title, description, keywords, author }) => {
  return (
    <div>
      <Helmet>
        <meta charSet='utf-8' />
        <meta name='description' content={description} />
        <meta name='author' content={author} />
        <title>{title}</title>
      </Helmet>
      <Header />
      <main style={{ marginTop: '50px' }}>{children}</main>

      {/* Outside <main> so the live region is never part of the page flow -
          sitting above {children} meant a toast appearing or closing could
          nudge the content below it. */}
      <ToastContainer
        position='top-center'
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
        theme='light'
      />
    </div>
  )
}

Layout.defaultProps = {
  title: 'POS System',
  description: 'Gospel Book Centre PLT',
  author: 'Gospel Book Centre PLT',
}

export default Layout
